import type { SKURuleCategory, SKURuleCategoryKey } from './types';

/**
 * Category information for SKU rules
 * Describes behavior and examples for each rule type
 */
export const categoryInfo: Record<SKURuleCategoryKey, SKURuleCategory> = {
  standardGarments: {
    title: "Standard Garments",
    description: "Takes first 3 parts: GARMENT-SIZE-COLOR",
    example: "HT-L-BK-SUFFIX → HT-L-BK, TEE-M-WH-SUFFIX → TEE-M-WH",
    color: "bg-blue-50 border-blue-200"
  },
  doubleSidedPrefixes: {
    title: "Double-Sided Prefixes",
    description: "Removes '2' prefix, then applies standard rule",
    example: "2HT-L-BK-SUFFIX → HT-L-BK",
    color: "bg-purple-50 border-purple-200"
  },
  firstTwoSegments: {
    title: "First Two Segments",
    description: "Takes first 2 parts: GARMENT-TYPE",
    example: "TB-SPECIAL-CODE123 → TB-SPECIAL, CSH-NT-TH145 → CSH-NT",
    color: "bg-green-50 border-green-200"
  },
  wrapperTypes: {
    title: "Wrapper Types",
    description: "Extracts inner SKU after wrapper prefix (2 or 3 segments based on inner type)",
    example: "CUST-TEE-M-BK-SUFFIX → TEE-M-BK, CUST-CSH-WH-CODE → CSH-WH",
    color: "bg-orange-50 border-orange-200"
  },
  passThrough: {
    title: "Pass-Through",
    description: "Returns unchanged",
    example: "AF-SPECIAL-CODE → AF-SPECIAL-CODE",
    color: "bg-gray-50 border-gray-200"
  }
};
